import classes from "./IconButton.module.scss";
import { useGameSounds } from "@educaplay/core/hooks";
import { NAME_SOUND_ACTIVE } from "@educaplay/core/utils";
import clsx from "clsx";
import PropTypes from "prop-types";

export default function IconButton(props) {
    const { Icon, onClick, label, className, disabled, variant = "default", lectormsg } = props;

    const gameSounds = useGameSounds();
    const buttonClasses = clsx(classes.iconButton, className, !label && classes.withoutLabel, variant === 'primary' && classes.primary);

    return (
        <button
            type='button'
            disabled={disabled}
            className={buttonClasses}
            onClick={onClick}
            onMouseEnter={() => gameSounds.play(NAME_SOUND_ACTIVE)}
            aria-label={lectormsg}
        >
            <Icon />

            {label && <span className={classes.label}>{label}</span>}
        </button>
    )
}

IconButton.propTypes = {
    Icon: PropTypes.elementType.isRequired,
    onClick: PropTypes.func.isRequired,
    label: PropTypes.string,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    variant: PropTypes.oneOf(['primary', 'default'])
}